const report = `${process.env.VUE_APP_URL}/api/v1/report`;
import { validateResponseError } from "@/store/utils.js";
export default {
  namespaced: true,
  state: {
    reportLineForm: {
      description: null,
      formula: "=",
      factor: 1,
      activity: null,
      category: "ACT",
      parent: null,
      code: null,
      calculated_driver_id: null,
      dimension: null
    },
    reportLines: [],
    activitiesValidatedId: [],
    driversValidatedId: [],
    hasResults: false,
    lastCalculation: [{
      calculation_id: null,
      finished_at: null,
      requested_by_user: null,
    }],
    debug: {
      mode: "logs",
      errors: [],
      logs: []
    },
    compareTree: false,
    mainTreemap: {
      dimensionSelected: null,
      reportLinesSelected: [],
      scenarioSelected: null,
    },
    compare: {
      dimensionSelected: null,
      reportLinesSelected: [],
      scenarioSelected: null,
    },
    topSelected: "top",
    limitSelected: 50,

    parentDimensionSelected: null,
    chilDimensionSelected: null,

    compareWhale:false,
    reportLineSelected: null,
    scenariosSelected: [],

    validationScenario: null,

    reportLineSelectedWaterfall: null,

    selectedDimensionRecords:[]

  },
  getters: {
    getDebugData(state) {
      return state.debug[state.debug.mode];
    }
  },
  mutations: {
    SET_DIMENSION_RECORDS(state, data){
      state.selectedDimensionRecords = data
    },
    SET_HAS_RESULTS(state, data) {
      state.hasResults = data
    },
    SET_CATEGORY_LINE(state, payload) {
      state.reportLineForm.category = payload;
    },
    SET_REPORT_LINES(state, data) {
      if (!data) {
        return
      }
      state.reportLines = data?.sort((a, b) => {
        if (a.rank < b.rank) {
          return -1;
        }
        if (a.rank > b.rank) {
          return 1;
        }
        return 0;
      }
      );
    },
    SET_PARENT_LINE(state, data) {
      state.reportLineForm.parent = data;
    },
    SET_CODE_LINE(state, data) {
      state.reportLineForm.code = data;
    },
    SET_DESCRIPTION_LINE(state, data) {
      state.reportLineForm.description = data;
    },
    SET_FORMULA_LINE(state, data) {
      state.reportLineForm.formula = data;
    },
    SET_ACTIVITY_LINE(state, data) {
      state.reportLineForm.activity = data;
    },
    SET_MULTIPLICATION_FACTOR_LINE(state, data) {
      state.reportLineForm.factor = data;
    },
    SET_CALCULATED_DRIVER_LINE(state, data) {
      state.reportLineForm.calculated_driver_id = data;
    },
    CLEAR_LINE_FORM(state) {
      state.reportLineForm = {
        description: null,
        formula: "=",
        factor: 1,
        activity: null,
        category: "ACT",
        parent: null,
        code: null,
        calculated_driver_id: null,
        dimension: null
      }
    },
    SET_LINE_FORM(state, data) {
      state.reportLineForm = {
        id: data.id,
        description: data.description,
        formula: data.formula,
        factor: data.factor,
        activity: data.activity,
        category: data.category,
        parent: data.parent,
        rank: data.rank,
        code: data.code,
        calculated_driver_id: data.calculated_driver_id,
        dimension: data.dimension
      }
    },
    SET_ACTIVITIES(state, data) {
      state.activitiesValidatedId = data;
    },
    SET_DRIVERS(state, data) {
      state.driversValidatedId = data;
    },
    SET_LAST_CALCULATION(state, data) {
      if (!data) {
        return;
    }
    state.lastCalculation = data;
  },
    CLEAR_RESULTS_DATA(state) {
      state.lastCalculation = [{
        calculation_id: null,
        finished_at: null
      }]
    },
    SET_DEBUG_MODE(state, data) {
      state.debug.mode = data
    },
    SET_DEBUG_LOGS(state, data) {
      state.debug.logs = data;
    },
    SET_MAINTREEMAP_DIMENSION_SELECTED(state, data) {
      state.mainTreemap.dimensionSelected = data;
      state.compare.dimensionSelected = data;
    },
    SET_COMPARE_DIMENSION_SELECTED(state, data) {
      state.compare.dimensionSelected = data;
    },
    SET_MAINTREEMAP_REPORT_LINES_SELECTED(state, data) {
      state.mainTreemap.reportLinesSelected = data;
      state.compare.reportLinesSelected = data;
    },
    SET_COMPARE_REPORT_LINES_SELECTED(state, data) {
      state.compare.reportLinesSelected = data;
    },
    SET_MAINTREEMAP_SCENARIO_SELECTED(state, data) {
      state.mainTreemap.scenarioSelected = data;
    },
    SET_COMPARE_SCENARIO_SELECTED(state, data) {
      state.compare.scenarioSelected = data;
    },
    SET_TOP_SELECTED(state, data) {
      state.topSelected = data;
    },
    SET_LIMIT_SELECTED(state, data) {
      state.limitSelected = data;
    },
    SET_PARENT_DIMENSION_SELECTED(state, data) {
      state.parentDimensionSelected = data;
    },
    SET_CHILD_DIMENSION_SELECTED(state, data) {
      state.chilDimensionSelected = data;
    },
    SET_REPORT_LINE_SELECTED(state, data) {
      state.reportLineSelected = data;
    },
    SET_SCENARIOS_SELECTED(state, data) {
      state.scenariosSelected = data;
    },
    SET_COMPARE_TREE(state, data) {
      state.compareTree = data;
    },
    SET_COMPARE_WHALE(state, data) {
      state.compareWhale = data;
    },
    SET_VALIDATION_SCENARIO(state, data) {
      state.validationScenario = data;
    },
    SET_REPORT_LINE_SELECTED_WATERFALL(state, data) {
      state.reportLineSelectedWaterfall = data;
    },
  },

  actions: {
    getReportLine({ commit }, { context, id }) {
      return context.$http.get(`${report}/lines/${id}/`)
        .then(res => {
          commit("SET_LINE_FORM", res.data);
        });
    },
    deleteReportLine({ state }, { context, id }) {
      return context.$http.delete(`${report}/lines/${id}`);
    },
    createReportLine({ rootState, state }, { context, mode, modelId }) {
      let postUrl = `${report}/lines/`;
      let data = { ...state.reportLineForm, model: modelId };

      if (data.category == "DRI") {
        let driver = data.driver
        let calcDriver = rootState.calculatedDriversBeta.pnlDrivers.filter(cd => cd.calculated_driver_id == driver)[0]
        console.log("CALC DRIVER", calcDriver)
        if (calcDriver) {
          data.dimension = calcDriver.__dimension_id__
        }
      }
      data.parent = data.parent == 0 ? null : data.parent

      if (data.category != "FOR") {
        delete data.formula;
      }

      if (data.category != "ACT") {
        delete data.activity;
      }

      if (data.category != "DRI") {
        delete data.calculated_driver_id;
        delete data.dimension;
      }


      if (mode == "UPDATE") {
        return context.$http.put(`${postUrl}${data.id}/`, data)
          .then((res) => {
            console.log(res.data);
          });
      }
      return context.$http.post(postUrl, data)
        .then((res) => {
          console.log(res.data);
        });
    },
    getLastCalculationDetails({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${process.env.VUE_APP_URL}/api/v1/report/calculation/?scenario=${scenarioId}`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
        });
    },
    getCalculationLogs({ commit, state }, { context }) {
      let resultUrl = `${process.env.VUE_APP_URL}/api/v1/report/calculation-logs/?calculation=${state.lastCalculation[0].calculation_id}`
      return context.$http.get(resultUrl)
        .then(res => {
          commit("SET_DEBUG_LOGS", res.data[0].detail)
        }).catch(err => {
          validateResponseError(this, err, "report");
        })
    },
    calculateResults({ commit, state }, { context, scenarioId }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${process.env.VUE_APP_URL}/api/v1/report/reports/generate/`;

      return context.$http.post(resultsUrl, { scenario: scenarioId })
        .then(res => {
          commit("SET_LAST_CALCULATION", [res.data])
          return true
        });
    },
    cancelCalculation({ dispatch, commit }, { context, scenarioId, calculationID }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl =  `${process.env.VUE_APP_URL}/api/v1/report/calculation/stop-calculation/`;
      let payload = {
        calculation_id: calculationID
      }
      return context.$http.post(resultsUrl, payload)
      .then(() => {
        return dispatch("getLastCalculationDetails",{context:context, scenarioId: scenarioId})
      });
    },
  }
}
